import React from 'react'
import Navbar from '../components/navbar'
import Timeline from '../components/timeline'

export default function Home() {
    return (
        <div>
            <Navbar />
            <Timeline />
        </div>
    )
}
